/* handles showing temporary closed or new stops*/
module.exports = {
  name: 'tempstop',
  props: {
    tempStopData: {
      type: Array,
      required: true,
    },

    // currentCity: {
    //   type: String,
    //   required: true,
    // },
  },

  computed: {
    tempClosedStops() {
      const tempClosedStopData = this.tempStopData.filter(stop => {
        return !!Number(stop.temporarily_closed);
      })
      // return alphabetically sorted array of stops
      return tempClosedStopData;
    },

    sortedTempClosedStops() {
      return this.objectSorterByString(this.tempClosedStops, 'stop_name');
    },

    tempNewStops() {
      const tempNewStopData = this.tempStopData.filter(stop => {
        return !!Number(stop.temporary_new_stop);
      })
      // return alphabetically sorted array of stops
      return tempNewStopData;
    },

    sortedTempNewStops() {
      return this.objectSorterByString(this.tempNewStops, 'stop_name');
    }

  },

  methods: {
    objectSorterByString(obj, itemToSortBy) {
      const sortedArray = [];

      for (let key in obj) {
        sortedArray.push([key, obj[key][itemToSortBy]]);
      }
      sortedArray.sort((a, b) => {
        const seqA = a[1];
        const seqB = b[1];
        if (seqA < seqB) {
          return -1;
        }
        if (seqA > seqB) {
          return 1;
        }
        // sequence must be equal
        return 0;
      });
      return sortedArray;
    },
  },

  render() {
    return(
      <div class="additional-city-stops">
        {this.tempClosedStops.length > 0 &&
          <div class="additional-city-stops__list additional-city-stops__list--closed">
            <h4>Temporary Closed Stops</h4>
            {this.sortedTempClosedStops.map(stop =>
              <div class="additional-city-stops__stop">
                {this.tempClosedStops[stop[0]].stop_name} [{this.tempClosedStops[stop[0]].temporary_note}]
              </div>
            )}
          </div>
        }
        {this.tempNewStops.length > 0 &&
          <div class="additional-city-stops__list additional-city-stops__list--new">
            <h4>Temporary Stops</h4>
            {this.sortedTempNewStops.map(stop =>
              <div class="additional-city-stops__stop">
                {this.tempNewStops[stop[0]].stop_name} [{this.tempNewStops[stop[0]].temporary_note}]
              </div>
            )}
          </div>
        }
      </div>
    );
  },
};
